import { render, staticRenderFns } from "./GlobalUploader.vue?vue&type=template&id=5c02118c&scoped=true"
import script from "./GlobalUploader.vue?vue&type=script&lang=js"
export * from "./GlobalUploader.vue?vue&type=script&lang=js"
import style0 from "./GlobalUploader.vue?vue&type=style&index=0&id=5c02118c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c02118c",
  null
  
)

export default component.exports